import React from "react";
import styled from "styled-components";

const TicketCompo = () => {
  return (
    <>
      <TicketsMain>Raise a Ticket</TicketsMain>
      <TicketPara>
        If you have any some proble using Money Manager software you can raise a
        ticket
      </TicketPara>
      <AccountCard>
        <div className="grid">
          <div>
            <label>Full Name*</label>
            <input type="text" name="" id="" />
          </div>
          <div>
            <label>Email Id*</label>
            <input type="email" name="" id="" />
          </div>
        </div>
        <div>
          <label>Subject*</label>
          <input type="text" name="" id="" />
        </div>
        <div className="grid"></div>
        <div>
          <label>Message*</label>
          <textarea cols="30" rows="3"></textarea>
        </div>
        <Save>Save Changes</Save>
      </AccountCard>
    </>
  );
};

export default TicketCompo;

const TicketsMain = styled.h3`
  font-weight: 500;
  font-size: 35px;
  font-family: "Source Serif Pro", serif;
  color: rgb(0, 104, 74);
`;

const TicketPara = styled.p`
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  color: rgb(0, 30, 43);
`;

const AccountCard = styled.form`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;
  width: 70%;
  padding: 20px 20px;

  .block {
    display: block;
  }
  .none {
    display: none;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    margin-bottom: 0.5rem;
  }
  div {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    label {
      font-weight: 500;
      font-size: 15px;
      color: rgb(0, 104, 74);
      margin-bottom: 3px;
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      padding: 8px 10px;
      border: 2px solid #3aaa35;
      border-radius: 6px;
      font-size: 15px;
      font-weight: 500;
      color: rgb(0, 30, 43);
    }
    textarea {
      width: 100%;
      border: none;
      outline: none;
      padding: 8px 10px;
      border: 2px solid #3aaa35;
      border-radius: 6px;
      font-size: 15px;
      font-weight: 500;
      color: rgb(0, 30, 43);
    }
  }

  @media only screen and (max-width: 991px) {
    width: 100%;
    .grid {
      grid-template-columns: 1fr;
    }
  }
`;

const Save = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 9px 15px;
  background-color: #3aaa35;
  border-radius: 8px;
  color: #fff;
  width: 21%;
  cursor: pointer;
  margin-top: 1rem;
  font-weight: 500;
  text-align: center !important;

  @media only screen and (max-width: 991px) {
    width: 45%;
  }
`;
